import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@web-app/utils/trpc';

type UsePrescriptionTasksOptions = {
  page: number;
  pageSize: number;
  enabled?: boolean;
};

export function usePrescriptionTasks({
  page,
  pageSize,
  enabled = true,
}: UsePrescriptionTasksOptions) {
  return trpc.prescriptionTasks.list.useQuery(
    { page, pageSize },
    { enabled, placeholderData: keepPreviousData },
  );
}
